import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const UsersFilled: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.9324 10.4478C14.8175 10.4478 17.1563 8.10897 17.1563 5.22389C17.1563 2.33882 14.8175 0 11.9324 0C9.04731 0 6.7085 2.33882 6.7085 5.22389C6.7085 8.10897 9.04731 10.4478 11.9324 10.4478Z"
        fill="currentColor"
      />
      <path
        d="M15.6112 10.8853C14.5518 11.5765 13.2895 11.9822 11.9326 11.9822C10.5757 11.9822 9.31338 11.5765 8.25395 10.8853C6.12399 11.758 4.62305 13.8496 4.62305 16.2941V17.1294C4.62305 17.7524 5.06029 18.2894 5.67141 18.4062C7.41696 18.7403 9.53073 19.0002 11.9326 19.0002C14.3344 19.0002 16.4482 18.7403 18.1937 18.4062C18.8057 18.2894 19.2421 17.7524 19.2421 17.1294V16.2941C19.2421 13.8505 17.7412 11.7589 15.6112 10.8853Z"
        fill="currentColor"
      />
      <path
        d="M18.0796 1.98096C18.0081 1.98096 17.9424 1.998 17.8717 2.00227C18.3933 2.96028 18.6908 4.05807 18.6908 5.2249C18.6908 7.08808 17.933 8.77653 16.71 10.0005C17.1404 10.1522 17.5972 10.2511 18.0796 10.2511C20.363 10.2511 22.2143 8.39981 22.2143 6.11643C22.2143 3.8322 20.363 1.98096 18.0796 1.98096Z"
        fill="currentColor"
      />
      <path
        d="M5.17438 5.22405C5.17438 4.05807 5.47099 2.96028 5.99347 2.00141C5.92358 1.99886 5.8571 1.98096 5.7855 1.98096C3.50213 1.98096 1.65088 3.8322 1.65088 6.11558C1.65088 8.39895 3.50213 10.2502 5.7855 10.2502C6.26792 10.2502 6.72476 10.1513 7.15519 9.99962C5.9321 8.77654 5.17438 7.08723 5.17438 5.22405Z"
        fill="currentColor"
      />
      <path
        d="M21.3284 10.7539C20.6823 11.2073 19.9357 11.5218 19.1328 11.6753C20.1667 12.9572 20.7761 14.5663 20.7761 16.2949V16.8813C21.5952 16.7969 22.3512 16.681 23.0347 16.5506C23.5189 16.4568 23.8649 16.0315 23.8649 15.5388V14.8774C23.8649 13.0756 22.8319 11.5176 21.3284 10.7539Z"
        fill="currentColor"
      />
      <path
        d="M3.08882 16.2939C3.08882 14.5654 3.69823 12.957 4.7321 11.6743C3.92921 11.5209 3.18258 11.2072 2.53651 10.7529C1.03302 11.5175 0 13.0755 0 14.8773V15.5387C0 16.0314 0.346043 16.4567 0.830163 16.5496C1.51373 16.6808 2.26974 16.7968 3.08882 16.8803V16.2939Z"
        fill="currentColor"
      />
    </svg>
  )
})

UsersFilled.displayName = 'UsersFilled'
